<template>
    <div>
        <div class="row mt-0">
            <div class="col-12" v-if="isLoading">
                <p>Carrgando os dados...</p>
            </div>
            <template v-else>
                <div class="col-4" v-for="(field, index) in inputs" :key="index">
                    <app-input-text :label="field.label" :icon="true" :contentType="12" :id="field.id"
                        :value="field.val.toString()" @input="updateOutros" @change="inputValueChange" />
                </div>
            </template>

        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import AppInputText from "@/components/AppInputText/AppInputTextFormats.vue";
export default {
    props: {
        task_id: {
            type: [String, Number]
        },
        userAdmin: { type: [Number, String], required: false }
    },
    components: {
        AppInputText
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            isLoading: true,
            inputs: [
                { "id": "ia", "label": "Qtda. de peças IA", "val": 0 },
                { "id": "iu", "label": "Qtda. de peças IU", "val": 0 },
                { "id": "ip", "label": "Qtda. de peças IP", "val": 0 },
                { "id": "pj", "label": "Qtda. de peças PJ", "val": 0 },
                { "id": "ibba", "label": "Qtda. de peças IBBA", "val": 0 },
                { "id": "private_asset_diso", "label": "Qtda. de peças Private/Asset/Diso", "val": 0 },
                { "id": "ion", "label": "Qtda. de peças íon", "val": 0 },
                { "id": "outas", "label": "Qtda. de peças outras", "val": 0 },
                { "id": "nao_correntistas", "label": "Qtda. de peças não correntistas", "val": 0 }
            ]
        }
    },
    methods: {
        ...mapActions([
            "showMessage"
        ]),
        async loadData() {
            const options = this.$getAPIHeaders(
                "GET",
                `task-numbers/${this.task_id}`
            );
            await this.axios(options)
                .then(response => {
                    if (response.data) {
                        const apiData = response.data.data;
                        if (apiData != null) {
                            this.inputs = this.inputs.map(field => ({
                                ...field,
                                val: apiData[field.id]
                            }));
                            this.sumFormatos();
                        }

                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error)
                });
        },
        async updateValue(key, value) {

            //pegar a descrição do campo
            let field = this.inputs.find(i => i.id === key);

            if (!field) {
                this.showMessage({
                    title: "Desculpe um erro aconteceu!",
                    css: "bg-danger"
                });
                return;
            }

            const data = {
                key: key,
                value: value,
                key_text: `Alterou a quantidade de "${field.label}" para `,
                value_text: value
            }
            const { url, options } = this.$getAPIHeadersFetch("PATCH", `task-numbers/${this.task_id}`, data);
            const response = await fetch(url, options);
            const result = await response.json();
            console.log(result);
        },
        updateOutros(v, k) {
            if (v != null && v != "") {
                this.inputs.forEach(e => {
                    if (e.id === k) {
                        console.log(e.id);
                        e.val = v;
                    }
                });
                this.sumFormatos();
                this.updateValue(k, v);
            }
        },
        inputValueChange(k, v) {
            console.log('inputValueChange', k, v)
        },
        sumFormatos() {
            const total = this.inputs.reduce((acc, obj) => {
                return parseInt(acc) + parseInt(obj.val);
            }, 0);
            let nao_correntistas = this.inputs.find(e => e.id === 'nao_correntistas');

            this.$emit('updateSegmentos', (total - nao_correntistas.val), nao_correntistas.val)
        }
    }

}
</script>